// src/pages/NewsPage.js
import React from 'react';
import NewsCard from '../components/NewsCard'; // Adjust path as necessary
import newsArticles from '../data/newsArticles'; // Import the data

const NewsPage = () => {
  return (
    <>
      <section className='container-fluid px-5 my-5 d-flex flex-column align-items-start justify-content-start w-100'>
        <h1 className="fw-bold mb-4">Our Latest News & Blogs</h1>
        {/* Add filtering/category options here if needed */}
        <div className="d-flex flex-wrap g-5">
          {newsArticles.map((article, index) => (
            <NewsCard
              key={index}
              imageUrl={article.imageUrl}
              category={article.category}
              date={article.date}
              title={article.title}
              description={article.description}
              detailsLink={article.detailsLink}
            />
          ))}
          {/* Add more news cards */}
        </div>
        {/* Load More Button */}
        <div className="mt-5 text-center">
          <button type="button" className="btn btn-outline-secondary">Load More News</button>
        </div>
      </section>
    </>
  );
};

export default NewsPage;